var render, staticRenderFns
import script from "./MixinCourseData.vue?vue&type=script&lang=js&"
export * from "./MixinCourseData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635cb9f8",
  null
  
)

export default component.exports